import { TaxonomyPattern } from "models/taxonomy"
import { http } from "./http"

export const fetchTaxonomyPatterns = async (
  _key: string,
  clientAgencyConfigId?: string,
) => {
  const searchParams = new URLSearchParams()
  !!clientAgencyConfigId &&
    searchParams.set("clientAgencyConfigId", clientAgencyConfigId)
  const { data } = await http
    .get("taxonomy-patterns", { searchParams })
    .json<{ data: TaxonomyPattern[] }>()
  return data
}

export const createTaxonomyPattern = async (
  pld: Partial<TaxonomyPattern>,
): Promise<TaxonomyPattern> => {
  const json = pld
  const res = await http.post("taxonomy-patterns", { json }).json()
  return res as TaxonomyPattern
}

export const updateTaxonomyPattern = async (
  pld: Partial<TaxonomyPattern>,
): Promise<TaxonomyPattern> => {
  const { clientAgencyConfigId, ...data } = pld
  const res = await http
    .put(`taxonomy-patterns/${clientAgencyConfigId}/content`, { json: data })
    .json()
  return res as TaxonomyPattern
}

export const toggleTaxonomyStatus = async (
  pld: Partial<TaxonomyPattern>,
): Promise<TaxonomyPattern> => {
  const { id, ...data } = pld
  const res = await http
    .put(`taxonomy-patterns/${id}/enabled`, { json: data })
    .json()
  return res as TaxonomyPattern
}

export const deleteTaxonomyTab = async (
  pld: Partial<TaxonomyPattern>,
): Promise<TaxonomyPattern> => {
  const json = pld
  const res = await http.delete("taxonomy-patterns", { json }).json()
  return res as TaxonomyPattern
}

export const createTaxonomyPatternPerSemantic = async (
  pld: Partial<TaxonomyPattern>,
): Promise<TaxonomyPattern> => {
  const json = pld
  const res = await http.post("taxonomy-patterns", { json }).json()
  return res as TaxonomyPattern
}
